// naviSearchの初期値とモデル ※naviSearch変数の内容が分かるように敢えてモデル化している
const naviSearchModel = {
  start: {
    name: '', // 出発地名称
    lat: null, // 緯度
    lon: null, // 経度
    marker: null, // 発マーカー
    forceSearch: false, // パラメータの値から強制的に検索するフラグ
  }, // 出発地
  end: {
    name: '', // 目的地名称
    lat: null, // 緯度
    lon: null, // 経度
    marker: null, // 着マーカー
    forceSearch: false, // パラメータの値から強制的に検索するフラグ
  },  // 目的地
  via: [], // 経由地
  reSearchFlag: false, // 再検索フラグ このフラグがtrueの場合は以前の検索結果があっても再び検索を実行する
  type: 'drive', // 'drive':車, 'walk':徒歩, 'transit':公共交通
  drive: {
    enc: 'UTF-8',
    chg: 1, // 有料区分 0:有料道路を利用しない, 1:有料道路を利用する
    smartic: 1, // スマートIC利用区分 0:利用しない, 1:利用する
    vt: 1, // 車種 0:軽自動車, 1:普通自動車, 2:中型車, 3:大型車, 4:特大車
    // ここから下はドライブの固定項目
    dtf: 1, // 0…距離優先で探索を行う、1…時間優先で探索を行う
    str: 0, // 直進優先
    etc: 0, // 誘導情報区分取得フラグ(ETCレーン)
    jct: 1, // 誘導情報区分取得フラグ(JCT/IC)
    cross: 0, // 誘導情報区分取得フラグ(交差点拡大図)
    cross3d: 1, // 誘導情報区分取得フラグ(3D交差点)
    distsign: 1, // 誘導情報区分取得フラグ(方面看板)
    lane: 0, // 誘導情報区分取得フラグ(進入レーン)
    sapa: 0, // 誘導情報区分取得フラグ(SA/PA)
    link: 0, // リンク情報フラグ 0…リンク情報は詳細情報を取得する 1…リンク情報は簡易情報を取得する 2…リンク情報を取得しない
    sic: 0, // スマートIC利用有無フラグ
    guideillust: 1,
    st_road_type: 1, // 有料道路上に出発地を設定
    ed_road_type: 1, // 有料道路上に目的地を設定
    m_road_type1: 1, // 有料道路上に経由地1を設定
    m_road_type2: 1, // 有料道路上に経由地2を設定
    m_road_type3: 1, // 有料道路上に経由地3を設定
    m_road_type4: 1, // 有料道路上に経由地4を設定
    m_road_type5: 1, // 有料道路上に経由地5を設定


    // ここから下はデフォルト設定項目
    grp : "all",
    masher: "Drive",
    island : "org",
    json: 1,
    type : "d",
    ie: "utf-8",
    oe: "utf-8"
  },
  driveResult: null, // ドライブルート検索結果のGeoJsonデータ格納用
  driveResultData: null, // ドライブルート検索結果のリンクデータ格納用
  resultRendered: false, // ルート検索結果が地図上に描画済みかどうかの判定に使用する
  walk: {
    psc: 0, // 0:距離が短い, 5:屋根が多い, 3:階段が少ない

    // ここから下はデフォルト設定項目
    grp: "all",
    masher: "Arrange",
    island : "org",
    json: 1,
    type : "w",
  },
  walkResult: null, // 歩きルート検索結果のGeoJsonデータ格納用
  walkResultData: null, // 歩きルート検索結果のリンクデータ格納用
  resultError: "", // 検索結果エラー状態のメッセージ
  transit: {
    // origin: "", // 出発の緯度経度 例 35.677348029692475,139.77660809945348 componentでセットする
    // destination: "", // 目的地の緯度経度 例 35.68963421500462,139.6921015739441
    transitMode: 0, // 0:出発, 1:到着, 2:始発, 3:終電
    date: '', // 日付 YYYYMMDD 例: 20251003
    time: '', // 時刻 HHMM 例: 1518
    mode: 'departure', // 'departure':出発, 'arrival':到着 ※終電と始発はtimeとdateで調整する
    air: 0, // 飛行機利用区分 0:利用しない, 1:利用する
    express: 0, // 有料特急有無 0:利用しない, 1:利用する
    transportation: [
      0,
      0,
      0,  // 飛行機を使う 0: 利用する 2: 利用しない
      0,  // 新幹線を使う 0: 利用する 2: 利用しない
      2,  // 有料特急を使う 0: 利用する 2: 利用しない
      2,  // 有料特急を使う 0: 利用する 2: 利用しない
      2,  // 有料特急を使う 0: 利用する 2: 利用しない
      0 
    ].join(''),
    sort: 'time,fare,transfer',
    /*
      時間順: 'time,fare,transfer'
      料金順: 'fare,time,transfer'
      乗り換え順: 'transfer,fare,time'
    */

    // ここから下はデフォルト設定項目
    routePtArr: 1, // ?
    stations: 2, // 最寄り駅検索数（1〜3）
    boundFor: 1, // 行き先表示指定  0:結果に行き先を含まない 1: 結果に行き先を含む
    speed: "3.2,40", // 徒歩,車の速度（km/h）
    dtm:"tky", // 日本測地系 or 世界測地系 tky:日本測地系, wgs:世界測地系 ※ドライブルートが日本測地系なので日本測地系にしておく
    island : "org", // 島ズレ補正 `"move"`または`"org"`
    candidates: 3, // 出力候補数 (3|5|10|20)
    transfertime: 0, // 乗り換え時間の設定 (0:標準、1:長めの時間、2:短めの時間、4:もっと長めの時間)
    ID: "mapion-pc", // ?
  },
  transitResult: null, // 乗り換え徒歩ルート検索結果のGeoJsonデータ格納用
  transitResultData: null, // 乗り換え徒歩ルート検索結果のリンクデータ格納用
  currentRouteIdx: 0, // 乗り換え徒歩ルートの現在表示中の経路インデックス
};

export default naviSearchModel;